import React from 'react';
import styled from 'styled-components';
import { token, Anchor } from '@zillow/constellation';
import { getCurrentUrl } from '../utils/windowUtils';
var ErrorWrapper = styled.div.withConfig({
  displayName: "ErrorMessage__ErrorWrapper",
  componentId: "sc-1nixetn-0"
})(["background:", ";border:1px solid ", ";padding:0.5em;"], token('colors.yellow100'), token('colors.orange400'));

var ErrorMessage = function ErrorMessage(_ref) {
  var children = _ref.children,
      _ref$shouldShowRefres = _ref.shouldShowRefreshPagePrompt,
      shouldShowRefreshPagePrompt = _ref$shouldShowRefres === void 0 ? false : _ref$shouldShowRefres;
  return /*#__PURE__*/React.createElement(ErrorWrapper, null, /*#__PURE__*/React.createElement("div", null, children), shouldShowRefreshPagePrompt && /*#__PURE__*/React.createElement("div", null, "Please ", /*#__PURE__*/React.createElement(Anchor, {
    href: getCurrentUrl()
  }, "refresh the page"), " and try again."));
};

export default ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map